import { Component, ElementRef, viewChild, effect, inject } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { DialogService } from './dialog.service';

@Component({
  selector: 'app-dialog-container',
  imports: [ NgComponentOutlet ],
  template: `
    @if(dialogService.activeComponent()) {
      <dialog #globalDialog (close)="dialogService.close()">
        <ng-container *ngComponentOutlet="dialogService.activeComponent()" />
      </dialog>
    }
  `,
  styles: `
    dialog::backdrop { background: var(--slate-dark-alpha-60); }
  `
})
export class DialogContainerComponent {
  protected readonly dialogService = inject(DialogService);

  private readonly dialogEl = viewChild<ElementRef<HTMLDialogElement>>('globalDialog');

  constructor() {
    // Reactively open/close the native dialog when the signal changes
    effect(() => {
      const el = this.dialogEl()?.nativeElement;
      if(this.dialogService.activeComponent()) {
        if(!el?.open) el?.showModal();
      }
      else {
        el?.close();
      }
    });
  }
}
